<template>
  <genera-fatture-clienti-gas />
</template>

<script>
import GeneraFattureClientiGas from '@/components/ask/pages/GeneraFattureClientiGas.vue'

export default {
  name: 'PageGeneraFattureClientiGas',

  components:{
    GeneraFattureClientiGas
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
